import { Component, OnInit } from '@angular/core';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PurchaseRegister } from 'src/app/models/purchase-register';
import { Purchase } from 'src/app/models/purchase';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';

@Component({
  selector: 'app-nova-compra',
  templateUrl: './nova-compra.component.html'
})
export class NovacompraComponent implements OnInit {

  constructor(
    private pedidoDataService: PedidoDataService, 
    private router: Router, 
    private route: ActivatedRoute,    
    private parametrosDataService: ParametrosDataService,
  ) { }

  private currentpurchaseValue: Purchase;
  private parametros: { [key: string]: string };
  public exibirNovaRecarga: boolean;
  public exibirRecargaArquivo: boolean = false;

  ngOnInit() { 

    this.parametros = this.parametrosDataService.currentParametrosValue;
    if (this.parametros[ParametrosKey.exibirNovaRecarga]) {
        this.exibirNovaRecarga = BooleanConverter.getBoolean(
            this.parametros[ParametrosKey.exibirNovaRecarga]
        );
    } else {
        this.exibirNovaRecarga = false;
    }

    if(this.router.url === '/portal/novarecarga/arquivo'){
      this.exibirRecargaArquivo = true;
    }

    this.currentpurchaseValue = this.pedidoDataService.currentPurchaseValue;
    if (!this.currentpurchaseValue && !this.exibirNovaRecarga) {
       // Não existe pedido na sessão
       this.router.navigate(['novarecarga'], { relativeTo: this.route.parent });
    }
  }

}
